import { IUserAccount } from '@/api/api-update';
import { strcmp } from '@/services/common';

export default class UserAccount {
  id: number;

  token: string;

  accountName: string;

  color: string;

  order: number;

  constructor(o?: IUserAccount) {
    this.id = o?.accountId ?? 0;
    this.token = o?.token ?? '';
    this.accountName = o?.accountName ?? 'N/A';
    this.color = o?.color?.toUpperCase() ?? '#3355FF';
    this.order = o?.order ?? 0;
  }

  // user-defined position first (0 = never ordered -> alphabetical tail)
  static compare(a: UserAccount, b: UserAccount): number {
    const ka = a.order > 0 ? a.order : Number.MAX_SAFE_INTEGER;
    const kb = b.order > 0 ? b.order : Number.MAX_SAFE_INTEGER;
    return (ka - kb) || strcmp(a.accountName, b.accountName);
  }
}
